<template>
  <b-list-group class="select-field">
    <component
      :is="labelTag"
      :class="{'mr-50': !labelTop, 'mb-0': !labelTop}"
    >{{ label }}</component>
    <v-select-field
      input-id="directions"
      :placeholder="placeholder"
      :no-options-text="noOptionsText"
      label-field="name"
      :options="directionsForDropdown"
      :multiple="multiple"
      :style="{ width: width, minWidth: minWidth }"
      @change="$emit('change', $event)"
    ></v-select-field>
  </b-list-group>
</template>

<script>

import VSelectField from '@/views/components/form/VSelectField.vue'
import { computed, onBeforeMount } from 'vue'
import { BListGroup } from 'bootstrap-vue'
import useDirection from '@/composables/direction'

export default {
  name: 'DirectionFilter',
  components: { BListGroup, VSelectField },
  emits: ['change'],
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    width: {
      type: [String, null],
      required: false,
      default: () => null,
    },
    minWidth: {
      type: [String, null],
      required: false,
      default: () => null,
    },
    labelTop: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    smallLabel: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  setup(props) {
    const label = computed(() => props.multiple ? 'Направления' : 'Направление')
    const placeholder = computed(() => props.multiple ? 'Не выбраны' : 'Не выбрано')
    const labelTag = computed(() => props.smallLabel ? 'label' : 'h6')
    const noOptionsText = computed(() => props.multiple ? 'Направления отсутствуют' : 'Направление отсутствует')
    const { directionsForDropdown, fetchDirectionsForDropdown } = useDirection()

    onBeforeMount(async () => await fetchDirectionsForDropdown())

    return {
      directionsForDropdown,
      labelTag,
      label,
      placeholder,
      noOptionsText,
    }
  }
}
</script>
